// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pRH-K","type":"styles_type__3aKLI","choices":"styles_choices__1g3tF"};